define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/_base",
	"csi/html",
	"csi/widget/froalaTextEditor",
	"./String"
], function(declare, _, csiHeading, html, froalaTextEditor, StringRen) {

	return declare(StringRen, {
		queryOps: [],
		tagAction: "ActionStringRich",

		/**
		 * @override
		 * Add CSS indicates that it contains rich text in the case of exporting to Excel
		 */
		_getRenderCSS: function(ctx, h, refNode) {
			return this.inherited(arguments) + (ctx.bExcel ? (" " + html.CSS_EXCEL_WRAP) : "");
		},

		canBeLarge: function(/*Context*/ctx, /*Heading*/h) {
			// summary: value could be large
			return ctx.getParam(csiHeading.CTX_LARGE_FORMAT) ? 2 : 1;
		},

		canLink: function() {
			// summary: doesn't make sense to support linking here
			return false;
		},

		/**
		 * @override
		 * Return true if cell is available for editing
		 */
		canPasteToCell(ctx, refNode) {
			return csiHeading.isHeadingNodeEditable(refNode);
		},

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: only allow filtering for blanks / non-blanks
			var qs = this.inherited(arguments);
			qs.blanksOnly = true;
			qs.ops = [];
			return qs;
		},

		/**
		 * @override
		 * Sanitize Rich Text
		 */
		headingToText: function(ctx, h) {
			const str = this.inherited(arguments);
			return html.sanitize(str);
		},

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: return widget to edit Rich Text
			params.csiRefNode = refNode;

			if (params.value == null) {
				params.value = this._getValue(ctx, h);
			}

			if (params.value) {
				params.value = html.sanitize(params.value.toString());
			}

			return new froalaTextEditor({
				value: params.value,
				csiRefNode: params.csiRefNode
			});
		},

		toHtmlQueryFilter: function(/*Context*/ctx, /*Spec*/spec, /*DOMNode*/refNode, /*Object*/params) {
			// summary: pass to String renderer rather than use rich text
			return StringRen.prototype.toHtmlDynamic.call(this, ctx, spec.heading, refNode, params);
		},

		_getAction: function() {
			// summary: create static action for editing attribute
			var a = this.inherited(arguments);
			a.canBeInlined = _.noop;
			return a;
		},

		_getCSS: function(/*String*/type, /*String?*/format) {
			// summary: use specific CSS class for rich text
			return this.inherited(arguments) + " " + html.CSS_RICH_TEXT;
		},

		_toHtmlString: function(/*String*/value, /*DOMNode*/refNode, /*Boolean*/bCanLink) {
			// summary: render value for attribute
			html.richText(value, refNode);

			// remove all empty p,span,div before displaying, legacy data support
			$(refNode).find('p:empty, span:empty, div:empty').remove();
		}
	});
});